exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-03952c63] {\n  padding-bottom: 1rem;\n}\n", ""]);

// exports
